"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartExtendedContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _SvgBtChart = require("../svg/icons/SvgBtChart");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c3e4f35a3{background:var(--color-flomni-bg-3);border-radius:var(--border-radius-def);padding:1.5625rem 1.5625rem;display:grid;grid-template-rows:fit-content(100%) fit-content(100%) 1fr fit-content(100%);grid-gap:1.125rem;grid-gap:1.125rem;grid-gap:1.125rem;gap:1.125rem}.c1788a714{display:grid;grid-template-columns:1fr fit-content(100%);margin-top:-.3125rem;margin-right:-.3125rem;grid-gap:1rem;grid-gap:1rem;grid-gap:1rem;gap:1rem}.c25b971bf{font-size:1rem;font-weight:500;line-height:1.125rem;padding-top:.3125rem;color:var(--color-flomni-blue-70)}.cdd903236{display:block}.c347efb66{display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:1fr;grid-row-gap:0;grid-column-gap:1rem}.c25885b30{display:grid;grid-template-columns:fit-content(100%) 1fr;grid-gap:.5rem;grid-gap:.5rem;grid-gap:.5rem;gap:.5rem;align-items:center;color:var(--color-flomni-gray-90);min-height:1.75rem;font-size:.875rem;font-weight:400;line-height:1rem}.c8c02763a{font-size:.875rem;font-weight:500;line-height:1rem}.c27a70ff2{color:var(--color-flomni-gray-70);display:flex}");
var styles = {
  root: 'c3e4f35a3',
  header: 'c1788a714',
  title: 'c25b971bf',
  button: 'cdd903236',
  '-webkit-columns': 'c347efb66',
  columns: 'c347efb66',
  cell: 'c25885b30',
  bold: 'c8c02763a',
  icon: 'c27a70ff2'
};

var ChartExtendedContainer = function ChartExtendedContainer(props) {
  var children = props.children,
      title = props.title,
      classes = props.classes,
      button = props.button,
      columns = props.columns,
      labels = props.labels;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.button
  }, button)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.columns
  }, columns.map(function (row, index) {
    return row.map(function (item, i) {
      return !item ? /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(index).concat(i),
        className: cn.cell
      }, /*#__PURE__*/_react.default.createElement("div", null, "\xA0"), /*#__PURE__*/_react.default.createElement("div", null, "\xA0")) : /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(index).concat(i),
        className: cn.cell
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: cn.icon
      }, /*#__PURE__*/_react.default.createElement(_SvgBtChart.SvgBtChart, null)), /*#__PURE__*/_react.default.createElement("div", null, item));
    });
  })), /*#__PURE__*/_react.default.createElement("div", null, children), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.columns
  }, labels.map(function (_ref, index) {
    var label = _ref.label,
        value = _ref.value;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: cn.cell
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cn.bold
    }, label, ":"), /*#__PURE__*/_react.default.createElement("div", null, value));
  })));
};

exports.ChartExtendedContainer = ChartExtendedContainer;
ChartExtendedContainer.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  title: _propTypes.node.isRequired,
  button: _propTypes.node.isRequired,
  columns: (0, _propTypes.arrayOf)((0, _propTypes.arrayOf)(_propTypes.node)).isRequired,
  labels: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.node.isRequired,
    value: _propTypes.node.isRequired
  })).isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ChartExtendedContainer.defaultProps = {
  classes: {}
};